export const initialState = {
  open: false,
  msg: '',
  assertive: false,
  type: null
}
